import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { COLORS } from '@app/src/ui';
import { Icon } from '@app/src/common/Icon';
import { Modal } from '@app/src/common/Modal';
import { SearchResultsModal } from './SearchResultsModal';
import { SearchJobContext } from './SearchConstructor';
import {
  Wrapper,
  Placeholder,
  IconWrapper,
  Ubigeo,
  ContentModal,
  IconClose,
  LoaderWrapper,
  InputWrapper
} from './styled';

export const SearchInputModal: React.FC = () => {
  const {
    handleChange,
    handleClickClose,
    handleBlurInput,
    handleChangeInput,
    handleClickOpenModal,
    defaultJob,
    error,
    input,
    dataList,
    placeholder,
    isLoading,
    isLoadingModal,
    activeColor,
    minCharForSearch
  } = useContext(SearchJobContext);
  const [value, setValue] = useState('');
  const [currentValue, setCurrentValue] = useState('');
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const [suggestionsList, setSuggestionsList] = useState([]);
  const refWrapper = useRef(null);
  const refClose = useRef(null);
  const [displayModal, setDisplayModal] = useState(false);
  const refInput = useRef(null);

  useEffect(() => {
    if (dataList && dataList.length > 0) {
      setSuggestionsList(dataList);
    }
  }, [dataList]);

  useEffect(() => {
    if (defaultJob) {
      setValue(defaultJob);
      setCurrentValue(defaultJob);
    } else {
      clearInput();
    }
  }, [defaultJob]);

  useEffect(() => {
    if (suggestionsList[activeSuggestion]) {
      setValue(suggestionsList[activeSuggestion].name);
      setCurrentValue(suggestionsList[activeSuggestion].name);
      refInput.current.style.display = 'none';
    }
  }, [activeSuggestion]);

  useEffect(() => {
    if (displayModal && value) {
      refInput.current.style.display = 'none';
    }
  }, [displayModal, value]);

  const handleChangeRadioInput = (_value:string, index: number) => {
    setActiveSuggestion(index);
    handleChange && handleChange(suggestionsList[index]);
    setTimeout(() => {
      setDisplayModal(false);
    }, 200)
  }

  const handleClickCloseModal = () => {
    setDisplayModal(false);
  }

  const handleClickWrapper = useCallback(() => {
    setDisplayModal(true);
    handleClickOpenModal && handleClickOpenModal();
  }, [dataList])

  const onChangeProp = useCallback((e) => {
    const inputValue = e.target.value.replace(/\s\s+|\n/g, ' ');
    setCurrentValue(inputValue);
    if (inputValue.length >= minCharForSearch && inputValue !== value && !isLoading) {
      handleChangeInput && handleChangeInput(inputValue);
    }
  }, [value, isLoading])

  const handleClickClear = () => {
    refInput.current.style.display = 'block';
    refInput.current.focus();
    clearInput();
    handleClickClose && handleClickClose();
  }

  const handleClickCloseOutModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    setActiveSuggestion(-1);
    clearInput();
    handleClickClose && handleClickClose();
  }

  const handleBlur = () => {
    if (activeSuggestion === -1) {
      setValue('');
      handleChange && handleChange(null);
      handleBlurInput && handleBlurInput();
    }
  }

  const clearInput = () => {
    setValue('');
    setCurrentValue('');
    setActiveSuggestion(-1);
  }

  return (
  <React.Fragment>
    <Wrapper
      ref={refWrapper}
      onClick={() => !isLoadingModal && handleClickWrapper()}
      borderColor={`1px solid ${error ? 'red' : COLORS.GRAY}`}>
      <IconWrapper>
        <Icon data-name="icon-map" width="18" height="18" fill={COLORS.GRAY_PLACEHOLDER} />
      </IconWrapper>
      {
        value ?
          <React.Fragment>
            <Ubigeo>
            <span>{value}</span>
            </Ubigeo>
            {
              !isLoadingModal &&
              <IconClose onClick={handleClickCloseOutModal}>
                <Icon data-name="icon-close-bold" width="18" height="18" fill={COLORS.GRAY} />
              </IconClose>
            }
          </React.Fragment>
          :
          <React.Fragment>
            <Placeholder>
              <span>{placeholder}</span>
            </Placeholder>
            {
              isLoadingModal &&
              <LoaderWrapper>
                  <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
              </LoaderWrapper>
            }
          </React.Fragment>
      }
      </Wrapper>
      <Modal show={displayModal} closeModal={handleClickCloseModal} customBody>
        <ContentModal>
          <Wrapper>
            <IconWrapper>
              <Icon data-name="icon-map" width="18" height="18" fill={COLORS.GRAY_PLACEHOLDER} />
            </IconWrapper>
            <InputWrapper
              {...input}
              onChange={onChangeProp}
              ref={refInput}
              value={currentValue}
              autoComplete="off"
              onBlur={handleBlur}
            />
            {
              (currentValue === '') &&
                <Placeholder>
                  <span>{placeholder}</span>
                </Placeholder>
            }
            {
              (currentValue && currentValue === value) &&
                <Ubigeo>
                  <span>{value}</span>
                </Ubigeo>
            }
            {
              isLoading &&
              <LoaderWrapper>
                  <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
              </LoaderWrapper>
            }
            {
              (currentValue !== '' || value !== '') && !isLoading &&
                <IconClose onClick={handleClickClear} ref={refClose}>
                  <Icon data-name="icon-close-bold" width="18" height="18" fill={COLORS.GRAY} />
                </IconClose>
            }
          </Wrapper>
          <SearchResultsModal
            themeColor={activeColor}
            activeItem={activeSuggestion}
            dataList={suggestionsList}
            showFirstItems={5}
            handleChange={handleChangeRadioInput}
          />
        </ContentModal>
      </Modal>
  </React.Fragment>
)};
